import { useLang } from "../i18n/LanguageContext";
import { LANGS } from "../i18n/translations";
import { LogoMark } from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_DISPLAY, waLink } from "../constants/images";

const Footer = () => {
  const { t, lang, setLang } = useLang();

  const links = [
    { hash: "#usluge", label: t.nav.services, id: "services" },
    { hash: "#onama", label: t.nav.about, id: "about" },
    { hash: "#recenzije", label: t.nav.reviews, id: "reviews" },
    { hash: "#kontakt", label: t.nav.contact, id: "contact" },
  ];

  return (
    <footer className="bg-[#0D0F12] border-t border-white/10 py-14" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5 text-[#F4F1EA]">
            <LogoMark className="w-8 h-8" />
            <span className="font-display font-extrabold tracking-wide text-lg">
              <span className="text-[#D96B27]">BOOM</span>GRADNJA
            </span>
          </div>
          <p className="mt-4 text-sm text-[#94A3B8] leading-relaxed max-w-xs">{t.footer.tagline}</p>
        </div>

        <div>
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#D96B27]">{t.footer.navTitle}</p>
          <ul className="mt-4 space-y-2.5">
            {links.map((l) => (
              <li key={l.id}>
                <a href={l.hash} data-testid={`footer-link-${l.id}`} className="text-sm text-[#F4F1EA]/75 hover:text-[#D96B27] transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#D96B27]">{t.footer.langTitle}</p>
          <ul className="mt-4 space-y-2.5">
            {LANGS.map((l) => (
              <li key={l.code}>
                <button
                  data-testid={`footer-lang-${l.code}`}
                  onClick={() => setLang(l.code)}
                  className={`text-sm transition-colors ${l.code === lang ? "text-[#D96B27]" : "text-[#F4F1EA]/75 hover:text-[#D96B27]"}`}
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#D96B27]">{t.footer.contactTitle}</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <a href={PHONE_TEL} data-testid="footer-phone-link" className="text-[#F4F1EA]/85 hover:text-[#D96B27] transition-colors font-mono2" dir="ltr" style={{ display: "inline-block" }}>
                {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a
                href={waLink(t.contact.waMessage)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="text-[#F4F1EA]/85 hover:text-[#25D366] transition-colors font-mono2"
                dir="ltr"
                style={{ display: "inline-block" }}
              >
                {WHATSAPP_DISPLAY}
              </a>
            </li>
            <li className="text-[#94A3B8]">Sarajevo, Bosna i Hercegovina</li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono2 text-[11px] text-[#94A3B8]">© {new Date().getFullYear()} BoomGradnja — {t.footer.rights}</p>
        <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#94A3B8]/60">Gradilišta — Sarajevo i okolina</p>
      </div>
    </footer>
  );
};

export default Footer;
